import { helper } from '@ember/component/helper';
import isTesting from '../utils/is-testing';

export default helper(() => isTesting);
